import { render, staticRenderFns } from "./cephfs.vue?vue&type=template&id=243624a5&"
import script from "./cephfs.vue?vue&type=script&lang=js&"
export * from "./cephfs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports